module.exports = __webpack_public_path__ + "static/media/Trinidad Dr, Tiburon, CA3.3785e01f.jpg";